module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic"
  }, [_c('div', {
    staticClass: "topic-avatar"
  }, [_c('router-link', {
    attrs: {
      "to": '/users/' + _vm.item.user.id
    }
  }, [_c('img', {
    staticStyle: {
      "width": "48px",
      "height": "48px",
      "border-radius": "24px"
    },
    attrs: {
      "alt": _vm.item.user.login,
      "src": _vm.item.user.avatar_url
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "topic-infos"
  }, [_c('div', {
    staticClass: "topic-title"
  }, [_c('router-link', {
    attrs: {
      "to": '/topics/' + _vm.item.id
    }
  }, [_c('span', {
    staticClass: "topic-node"
  }, [_vm._v(_vm._s(_vm.item.node_name))]), _vm._v("\n        " + _vm._s(_vm.item.title) + "\n        "), (_vm.item.excellent === 1) ? _c('i', {
    staticClass: "fa fa-diamond",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "",
      "data-toggle": "tooltip",
      "data-original-title": "精华帖"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "topic-info"
  }, [_c('router-link', {
    attrs: {
      "to": '/users/' + _vm.item.user.id
    }
  }, [_vm._v(_vm._s(_vm.item.user.login))]), _vm._v(" "), (_vm.item.replies_count === 0) ? _c('span', [_vm._v(" · 发布于 " + _vm._s(_vm.publishTime) + " ")]) : _c('span', [_vm._v(" · 最后由 "), _c('router-link', {
    attrs: {
      "to": '/users/' + _vm.item.last_reply_user_id
    }
  }, [_vm._v(_vm._s(_vm.item.last_reply_user_login))]), _vm._v(" 回复于 " + _vm._s(_vm.replyTime) + " ")], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "topic-replies-count"
  }, [_c('span', {
    staticClass: "span-replies"
  }, [_vm._v(_vm._s(_vm.item.replies_count))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83b85ed0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Item.vue
// module id = 288
// module chunks = 6